import { FC } from "react";
import { Button } from "../../design-system";
import { ReactComponent as ThinkerIcon } from "../../assets/icons/svg/thinker-gradient.svg";
import styles from "./AskAssistantBubble.module.less";

interface Props {
    onClick: () => void;
    /** Tooltip / accessible label for the icon-only button. */
    label?: string;
    className?: string;
    /** Rendered as data-tour-id so a product tour can spotlight the bubble. */
    tourId?: string;
}

/**
 * Floating circular "Ask the assistant" button, fixed to the bottom-right of
 * the viewport so it stays in reach as an analysis view scrolls. Single source
 * of truth for the affordance so the Flexible, Deal, and RFX views stay
 * visually identical.
 */
export const AskAssistantBubble: FC<Props> = ({
    onClick,
    label = "Ask about this report",
    className,
    tourId,
}) => (
    <Button
        type="primary"
        shape="circle"
        className={`${styles.askBubble}${className ? ` ${className}` : ""}`}
        onClick={onClick}
        title={label}
        aria-label={label}
        data-tour-id={tourId}
    >
        <ThinkerIcon className={styles.askBubbleIcon} />
    </Button>
);
